export default __webpack_public_path__ + "static/wave2-87e6b527845f867e5852cb3aa7e643fe.png";